export const DOCUMENT_TYPE = {
	dni: {
		key: 'dni',
		label: 'DNI'
	},
	ce: {
		key: 'ce',
		label: 'Carnet de extranjería'
	}
}


// WEBPACK FOOTER //
// ./src/constants/app/document.js